import { render, staticRenderFns } from "./LabelModal6.vue?vue&type=template&id=a06afcc4&scoped=true&"
import script from "./LabelModal6.vue?vue&type=script&lang=js&"
export * from "./LabelModal6.vue?vue&type=script&lang=js&"
import style0 from "./LabelModal6.vue?vue&type=style&index=0&id=a06afcc4&prod&lang=scss&scoped=true&"
import style1 from "./LabelModal6.vue?vue&type=style&index=1&id=a06afcc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06afcc4",
  null
  
)

export default component.exports